import React from "react";
import ArchiveFormulariRizika from "../../components/admin/archiveFormulariRizika";

function ArchiveFormulariRizikaPage(props) {
  return (
    <div className="admin-page-child-wrapper">
      <ArchiveFormulariRizika />
    </div>
  );
}

export default ArchiveFormulariRizikaPage;
